//react
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//material-ui design helpers



import { LoadingDialog } from '../dialogs';
import {corestyles} from '../../styles';
import { createItemList } from '../form';
import { Box } from '@mui/material';

const s:any = {
  ...corestyles,
}

/**
 * -------------------------------------------------------------------
 * Service Panel
 * -------------------------------------------------------------------
 */
class TabbedPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode: this.props.mode,
      init: false,
      loading: false,
      fopen: false,
    };
  }

  handleChange = (name:any) => (event:any) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  startLoading = () => {
    this.setState({ loading: true });
  }

  stopLoading = () => {
    this.setState({ loading: false });
  }

  render = () => {
    const { mode, sdata, record, formatters, onChange, classes, selected, reset, cvalue, cuparams } = this.props;
    const { loading } = this.state;
    const extras = {selected, reset, cvalue, cuparams }
    //const formitems = generateItemList(mode, sdata, record, formatters, onChange);
    const formitems = createItemList(mode, sdata, record, formatters, onChange, extras);
    return (
      <Box sx={{...s.container}}>
        <Box component='form' id="requestform" sx={{...s.reqform}}>
          {loading &&
            <LoadingDialog status={loading} start={this.startLoading} stop={this.stopLoading} />
          }
          {formitems.map((item:any) => (
            <Box key={item.id}>{item.dom}</Box>
          ))}
        </Box>
      </Box>
    );
  }
};

// TabbedPanel.propTypes = {
//   service: PropTypes.string.isRequired,
//   mode: PropTypes.oneOf(['add', 'edit', 'delete', 'view', 'close', 'manage', 'wizard']).isRequired,
//   sdata: PropTypes.object,
//   record: PropTypes.object,
//   onChange: PropTypes.func,
//   formatters: PropTypes.object,
//   layout: PropTypes.object,
// };

//TabbedPanel = withStyl...corestyles, { withTheme: true })(TabbedPanel);

export default TabbedPanel;
